// extracted by css-extract-rspack-plugin
var _1 = "ec";
var _2 = "ea";
var _3 = "eb";
var _4 = "ei";
var _5 = "eh";
var _6 = "ej";
var _7 = "ef";
var _8 = "ee";
var _9 = "c9";
var _a = "eg";
export { _1 as "brandItem", _2 as "brands", _3 as "brandsTitle", _4 as "discountSliderGroupComponent", _5 as "discounts", _6 as "loadingComponent", _7 as "offers", _8 as "shop", _9 as "shoppingMallTabBrandsComponent", _a as "shoppingMallTabBrandsItemComponent" }
